// The collection-locker picker.
//
// Injected into webshop's cart page rather than shipped as a template copy. Frappe's
// _get_jloader searches apps in REVERSED install order, so a copy of
// templates/includes/cart/cart_address.html would win -- and would then diverge
// silently on the next webshop upgrade, which is a fork patch wearing a different
// hat. The cart already emits `data-section` anchors and drives its own address cards
// from cart.js plus whitelisted endpoints, so this follows the mechanism that is
// already there.
//
// Two rules the UI obeys, both from the operator:
//   1. No shipping address, no picker. The recipient name, email and mobile sent to
//      the carrier come from that address, so choosing a locker first would book a
//      collection nobody can be notified about.
//   2. Once a locker is chosen, collapse the shipping address -- the customer is not
//      being delivered to, and should not be re-reading a delivery address.

frappe.provide("za_courier_guy");

za_courier_guy.checkout = {
	SELECTOR: "#cgza-picker",

	shippingCard() {
		const section = document.querySelector('[data-section="shipping-address"]');
		return section ? section.closest(".frappe-card") || section : null;
	},

	mount() {
		const anchor = document.querySelector('[data-section="shipping-address"]');
		if (!anchor || document.querySelector(za_courier_guy.checkout.SELECTOR)) return;

		const card = document.createElement("div");
		card.className = "mb-3 frappe-card p-5";
		card.id = "cgza-picker";
		// innerHTML here is the static shell ONLY: every interpolation is a `__()`
		// translation literal, and no carrier or user data reaches it. Everything
		// that does -- locker names, addresses, landmarks -- is written with
		// textContent below. Keep it that way.
		card.innerHTML = `
			<div class="d-flex">
				<div class="col-6 address-header"><h6>${__("Courier Guy delivery")}</h6></div>
			</div>
			<hr>
			<div class="cgza-loading small text-muted mb-2" hidden></div>
			<div class="cgza-services mb-3" hidden>
				<div class="form-check">
					<input class="form-check-input cgza-door" type="radio"
						name="cgza-service" id="cgza-service-door" value="Door">
					<label class="form-check-label" for="cgza-service-door">
						<span class="cgza-door-label"></span>
					</label>
				</div>
				<div class="form-check">
					<input class="form-check-input cgza-locker" type="radio"
						name="cgza-service" id="cgza-service-locker" value="Locker">
					<label class="form-check-label" for="cgza-service-locker">
						<span class="cgza-locker-label"></span>
					</label>
				</div>
			</div>
			<div class="cgza-chosen mb-2"></div>
			<div class="cgza-search">
				<div class="input-group mb-2">
					<input type="text" class="form-control cgza-query"
						placeholder="${__("Suburb, town or locker name")}"
						aria-label="${__("Search lockers")}">
					<button class="btn btn-secondary cgza-near" type="button">${__("Near me")}</button>
				</div>
				<div class="cgza-results list-group"></div>
			</div>`;
		anchor.parentNode.insertBefore(card, anchor.nextSibling);

		card.querySelector(".cgza-door").addEventListener("change", (e) => {
			if (e.target.checked) za_courier_guy.checkout.chooseDoor();
		});
		// Choosing Locker only reveals the picker. Nothing is saved until a locker is
		// picked, because a service with no locker would leave the order half-set.
		card.querySelector(".cgza-locker").addEventListener("change", (e) => {
			if (!e.target.checked) return;
			card.querySelector(".cgza-search").hidden = false;
			// Replace any "Delivering to…" left by the Door state: it would otherwise sit
			// above a locker search that has nothing chosen.
			const chosen = card.querySelector(".cgza-chosen");
			chosen.textContent = "";
			const hint = document.createElement("div");
			hint.className = "small text-muted";
			hint.textContent = __("No locker chosen yet.");
			chosen.appendChild(hint);
		});

		card.querySelector(".cgza-query").addEventListener(
			"input",
			frappe.utils.debounce((e) => {
				za_courier_guy.checkout.search({ query: e.target.value });
			}, 300),
		);

		card.querySelector(".cgza-near").addEventListener("click", () => {
			if (!navigator.geolocation) {
				frappe.msgprint(
					__("Your browser cannot share a location. Try searching by suburb."),
				);
				return;
			}
			navigator.geolocation.getCurrentPosition(
				(pos) =>
					za_courier_guy.checkout.search({
						lat: pos.coords.latitude,
						lng: pos.coords.longitude,
					}),
				() =>
					frappe.msgprint(__("Could not read your location. Try searching by suburb.")),
			);
		});

		za_courier_guy.checkout.refresh();
	},

	search(args) {
		frappe.call({
			method: "za_courier_guy.api.checkout.search_lockers",
			args,
			callback: (r) => za_courier_guy.checkout.render(r.message || []),
		});
	},

	render(rows) {
		const list = document.querySelector("#cgza-picker .cgza-results");
		if (!list) return;
		list.textContent = "";

		if (!rows.length) {
			const empty = document.createElement("div");
			empty.className = "small text-muted";
			empty.textContent = __("No lockers found. Try a different suburb.");
			list.appendChild(empty);
			return;
		}

		rows.forEach((row) => {
			const item = document.createElement("button");
			item.type = "button";
			item.className = "list-group-item list-group-item-action";

			// textContent throughout: locker names, addresses and landmarks are
			// carrier-supplied strings and must never be interpolated into innerHTML.
			const title = document.createElement("div");
			title.className = "font-weight-bold";
			title.textContent = row.point_name;

			const detail = document.createElement("div");
			detail.className = "small text-muted";
			detail.textContent = [row.address, row.landmark].filter(Boolean).join(" — ");

			item.append(title, detail);

			if (row.distance_km !== undefined) {
				const distance = document.createElement("div");
				distance.className = "small text-muted";
				distance.textContent = __("{0} km away", [row.distance_km]);
				item.appendChild(distance);
			}

			item.addEventListener("click", () => za_courier_guy.checkout.choose(row.code));
			list.appendChild(item);
		});
	},

	STYLE_ID: "cgza-busy-style",

	ensureBusyStyles() {
		if (document.getElementById(za_courier_guy.checkout.STYLE_ID)) return;
		// Injected rather than shipped as a CSS bundle: this app has no CSS bundle,
		// and adding one buys a second build artefact for eight rules.
		const style = document.createElement("style");
		style.id = za_courier_guy.checkout.STYLE_ID;
		style.textContent = [
			".cgza-busy{position:fixed;inset:0;z-index:2000;display:flex;align-items:center;",
			"justify-content:center;background:rgba(0,0,0,.45)}",
			".cgza-busy[hidden]{display:none}",
			".cgza-busy-box{display:flex;align-items:center;gap:.75rem;background:#fff;",
			"color:#1f272e;padding:1rem 1.25rem;border-radius:.5rem;",
			"box-shadow:0 8px 24px rgba(0,0,0,.2);font-size:.95rem;max-width:80vw}",
			".cgza-busy-spinner{width:1.25rem;height:1.25rem;flex:0 0 auto;",
			"border:2px solid rgba(0,0,0,.15);border-top-color:#264796;border-radius:50%;",
			"animation:cgza-spin .7s linear infinite}",
			// Slowed, not removed: a spinner that does not move conveys nothing.
			"@media (prefers-reduced-motion:reduce){.cgza-busy-spinner{animation-duration:2.4s}}",
			"@keyframes cgza-spin{to{transform:rotate(360deg)}}",
		].join("");
		document.head.appendChild(style);
	},

	busy(message) {
		za_courier_guy.checkout.ensureBusyStyles();
		let overlay = document.getElementById("cgza-busy");
		if (!overlay) {
			overlay = document.createElement("div");
			overlay.id = "cgza-busy";
			overlay.className = "cgza-busy";
			// Announced as well as drawn -- a spinner alone tells a screen reader nothing.
			overlay.setAttribute("role", "status");
			overlay.setAttribute("aria-live", "polite");
			const box = document.createElement("div");
			box.className = "cgza-busy-box";
			const spinner = document.createElement("div");
			spinner.className = "cgza-busy-spinner";
			const text = document.createElement("div");
			text.className = "cgza-busy-text";
			box.append(spinner, text);
			overlay.appendChild(box);
			document.body.appendChild(overlay);
		}
		overlay.querySelector(".cgza-busy-text").textContent = message;
		overlay.hidden = false;
	},

	idle() {
		const overlay = document.getElementById("cgza-busy");
		if (overlay) overlay.hidden = true;
	},

	choose(code) {
		// No mobile is sent. The number comes from the shipping address, which the checkout
		// address form already captures -- asking again here was the double entry the
		// operator asked to remove. The RULE is unchanged: the server still refuses a
		// locker when that address cannot be SMSed.

		// Our own overlay, NOT frappe.call's `freeze`. frappe.freeze lives in
		// frappe/dom.js, which is not among frappe-web.bundle.js's imports, so on a
		// portal page `freeze: true` was a silent no-op -- which is exactly why the
		// click read as if nothing had happened.
		za_courier_guy.checkout.busy(__("Updating shipping details…"));
		frappe.call({
			method: "za_courier_guy.api.checkout.set_collection_locker",
			args: { terminal: code },
			error: () => {
				// Never strand the customer behind an overlay they cannot dismiss.
				za_courier_guy.checkout.idle();
			},
			callback: () => {
				// Reload, exactly as webshop's own apply_coupon_code and
				// remove_coupon_code do. Choosing a locker changes the order total,
				// and webshop has NO working client-side path to redraw the Payment
				// Summary: cart.js:136 calls `shopping_cart.render(r.message)`, which
				// is referenced once and defined nowhere in the app -- its own
				// shipping-rule dropdown throws TypeError there and leaves the summary
				// stale too. Repainting only this card is what made the delivery line
				// appear solely after a manual refresh.
				// The overlay is deliberately left up: the reload paints over it, so
				// it covers the whole wait instead of flickering off mid-gap.
				window.location.reload();
			},
		});
	},

	chooseDoor() {
		// Same shape as choose(): our own overlay (frappe.call's `freeze` is a no-op on
		// portal pages) and a reload on success (framework#223 -- the order total changes
		// and webshop cannot redraw the Payment Summary client-side). The server refuses
		// a door delivery when the address mobile is not South African; the overlay
		// is dropped on error so the customer is never stranded behind it.
		za_courier_guy.checkout.busy(__("Updating shipping details…"));
		frappe.call({
			method: "za_courier_guy.api.checkout.set_door_delivery",
			error: () => {
				za_courier_guy.checkout.idle();
				// The radio now shows a choice the server refused; re-read the truth.
				za_courier_guy.checkout.refresh();
			},
			callback: () => {
				window.location.reload();
			},
		});
	},

	refresh() {
		// The prices take a few seconds. Say so: the bare card read as broken -- two
		// unlabelled radio buttons, and for ever when the call failed (za-courier-guy#26).
		za_courier_guy.checkout.showLoading(__("Getting Courier Guy delivery prices…"));
		frappe.call({
			method: "za_courier_guy.api.checkout.get_collection_state",
			callback: (r) => za_courier_guy.checkout.paint(r.message || {}),
			error: () =>
				za_courier_guy.checkout.showLoading(
					__("Couldn't get delivery prices — refresh the page to try again."),
					false,
				),
		});
	},

	showLoading(message, spinning = true) {
		const card = document.querySelector(za_courier_guy.checkout.SELECTOR);
		if (!card) return;
		za_courier_guy.checkout.ensureBusyStyles();
		// The options and the search stay hidden until paint() has prices to show.
		card.querySelector(".cgza-services").hidden = true;
		card.querySelector(".cgza-search").hidden = true;
		card.querySelector(".cgza-chosen").textContent = "";
		const row = card.querySelector(".cgza-loading");
		row.textContent = "";
		// Announced as well as drawn, like the busy overlay.
		row.setAttribute("role", "status");
		row.setAttribute("aria-live", "polite");
		row.style.display = "flex";
		row.style.alignItems = "center";
		row.style.gap = ".5rem";
		if (spinning) {
			const spinner = document.createElement("div");
			spinner.className = "cgza-busy-spinner";
			row.appendChild(spinner);
		}
		const text = document.createElement("span");
		text.textContent = message;
		row.appendChild(text);
		row.hidden = false;
	},

	hideLoading() {
		const row = document.querySelector(`${za_courier_guy.checkout.SELECTOR} .cgza-loading`);
		if (!row) return;
		row.hidden = true;
		row.style.display = "none";
		row.textContent = "";
	},

	paint(state) {
		const card = document.querySelector(za_courier_guy.checkout.SELECTOR);
		if (!card) return;
		za_courier_guy.checkout.hideLoading();

		// Rule 1: no COMPLETE shipping details, no picker. Presence of an address is not
		// enough -- offering a locker for an address the courier cannot notify is an option
		// the customer can pick and then be refused, which is worse than one never offered.
		// The server decides what "ready" means (shipping_ready); this only renders it.
		const chosen = card.querySelector(".cgza-chosen");
		const search = card.querySelector(".cgza-search");
		const services = card.querySelector(".cgza-services");
		chosen.textContent = "";
		card.hidden = false;

		// No options yet, but say WHY rather than hiding the card. A hidden card left a
		// buyer whose number was not an SA mobile (a +27 landline, say) with no prompt at
		// all, and the server now refuses the order for want of a locker (za-courier-guy#17)
		// -- telling them to choose one from a picker they could not see.
		if (!state.shipping_ready) {
			services.hidden = true;
			search.hidden = true;
			const why = document.createElement("div");
			why.className = "small text-muted cgza-not-ready";
			why.textContent = state.has_shipping_address
				? __(
						"Add a South African mobile number to your shipping address to choose Courier Guy delivery. The courier sends the collection PIN by SMS.",
					)
				: __("Add a shipping address to choose Courier Guy delivery.");
			chosen.appendChild(why);
			za_courier_guy.checkout.collapseShipping(false);
			return;
		}
		services.hidden = false;

		// Prices and labels: textContent only. A null amount means the server could not
		// price that service (refused, or not ready), so the option is disabled, not hidden.
		// The price TEXT comes formatted from the server (door_price / locker_price). Never
		// format money here: frappe's money formatter exists on a portal page but throws
		// (it reads desk-only boot data), and that throw blanked this whole card.
		const doorRadio = card.querySelector(".cgza-door");
		const lockerRadio = card.querySelector(".cgza-locker");
		const doorLabel = card.querySelector(".cgza-door-label");
		const lockerLabel = card.querySelector(".cgza-locker-label");

		if (state.door_amount == null) {
			doorLabel.textContent = __("Deliver to my address") + __(" (unavailable)");
		} else {
			doorLabel.textContent = __("Deliver to my address — {0}", [state.door_price]);
		}
		doorRadio.disabled = state.door_amount == null;

		if (state.locker_amount == null) {
			lockerLabel.textContent = __("Collect from a locker") + __(" (unavailable)");
		} else {
			lockerLabel.textContent = __("Collect from a locker — {0}", [state.locker_price]);
		}
		lockerRadio.disabled = state.locker_amount == null;

		doorRadio.checked = state.service === "Door";
		lockerRadio.checked = state.service === "Locker";

		// za-courier-guy#16: a cart with nothing chosen gets the customer's saved locker,
		// through choose() so the SA-mobile check and the reload still apply. Tried ONCE per
		// page: webshop re-renders re-mount this card, and a refused locker must not be
		// retried on every re-mount.
		if (!state.service && state.saved_locker && !za_courier_guy.checkout._triedSaved) {
			za_courier_guy.checkout._triedSaved = true;
			za_courier_guy.checkout.choose(state.saved_locker);
			return;
		}

		if (!state.service) {
			const hint = document.createElement("div");
			hint.className = "small text-muted";
			hint.textContent = __("Choose how you'd like to receive your order.");
			chosen.appendChild(hint);
			search.hidden = true;
			za_courier_guy.checkout.collapseShipping(false);
			return;
		}

		if (state.service === "Door") {
			const dest = document.createElement("div");
			dest.className = "font-weight-bold";
			dest.textContent = __("Delivering to {0}", [state.door_address || ""]);
			chosen.appendChild(dest);
			if (state.message) {
				// The fee note (e.g. "Free Delivery"), as the Locker path shows it.
				const note = document.createElement("div");
				note.className = "small text-muted mt-1";
				note.textContent = state.message;
				chosen.appendChild(note);
			}
			search.hidden = true;
			// The address IS the destination here, so it stays visible.
			za_courier_guy.checkout.collapseShipping(false);
			return;
		}

		if (!state.terminal) {
			const hint = document.createElement("div");
			hint.className = "small text-muted";
			hint.textContent = __("No locker chosen yet.");
			chosen.appendChild(hint);
			search.hidden = false;
			za_courier_guy.checkout.collapseShipping(false);
			return;
		}

		// Confirm the choice in place instead of clearing back to an empty search.
		const name = document.createElement("div");
		name.className = "font-weight-bold";
		name.textContent = state.terminal.point_name;

		const where = document.createElement("div");
		where.className = "small text-muted";
		where.textContent = [state.terminal.address, state.terminal.landmark]
			.filter(Boolean)
			.join(" — ");

		chosen.append(name, where);

		if (state.message) {
			const note = document.createElement("div");
			note.className = "small text-muted mt-1";
			note.textContent = state.message;
			chosen.appendChild(note);
		}

		const change = document.createElement("button");
		change.type = "button";
		change.className = "btn btn-sm btn-secondary mt-2";
		change.textContent = __("Choose a different locker");
		change.addEventListener("click", () => {
			search.hidden = false;
			const input = card.querySelector(".cgza-query");
			if (input) input.focus();
		});
		chosen.appendChild(change);

		// Explicit save (za-courier-guy#16): nothing is remembered unless the customer ticks
		// this, so a one-off locker never replaces their usual one.
		if (state.can_save_default) {
			const wrap = document.createElement("div");
			wrap.className = "form-check mt-2";
			const box = document.createElement("input");
			box.type = "checkbox";
			box.className = "form-check-input cgza-save-default";
			box.id = "cgza-save-default";
			box.checked = state.saved_locker === state.terminal.code;
			const label = document.createElement("label");
			label.className = "form-check-label";
			label.htmlFor = "cgza-save-default";
			label.textContent = __("Save as my default locker");
			box.addEventListener("change", () => {
				box.disabled = true;
				frappe.call({
					method: "za_courier_guy.api.checkout.set_default_locker",
					args: { save: box.checked ? 1 : 0 },
					// Re-read on failure too, so the box never shows a state the server refused.
					always: () => za_courier_guy.checkout.refresh(),
				});
			});
			wrap.append(box, label);
			chosen.appendChild(wrap);
		}

		search.hidden = true;
		// Rule 2: collapse the shipping address once a locker is chosen.
		za_courier_guy.checkout.collapseShipping(true);
	},

	collapseShipping(collapsed) {
		const card = za_courier_guy.checkout.shippingCard();
		if (!card) return;
		// Collapse, not remove: the address is still what the carrier is told to
		// notify, and webshop still needs it to offer a shipping rule at all.
		card.classList.toggle("cgza-collapsed", !!collapsed);
		card.querySelectorAll(".address-container, .row.no-gutters").forEach((el) => {
			el.hidden = !!collapsed;
		});
	},
};

frappe.ready(() => {
	if (window.location.pathname.replace(/\/$/, "") !== "/cart") return;

	za_courier_guy.checkout.mount();

	// webshop re-renders the cart in place after an address or quantity change, which
	// removes this card. Re-mount when that happens, or the picker silently vanishes
	// the first time the customer edits anything.
	//
	// It ONLY re-mounts. An earlier version also called refresh() on every mutation,
	// which was a self-feeding loop: paint() sets `hidden` on nodes inside the very
	// subtree being observed, so each paint scheduled another refresh, forever --
	// a server round-trip every 250ms and a summary redrawn mid-flight.
	const host = document.querySelector(".cart-payment-addresses") || document.body;
	new MutationObserver(
		frappe.utils.debounce(() => {
			if (!document.querySelector(za_courier_guy.checkout.SELECTOR)) {
				za_courier_guy.checkout.mount();
			}
		}, 250),
	).observe(host, { childList: true, subtree: true });
});
